import styled from 'styled-components';

import { ContentMain } from 'shared/styles/components';

export const CompanyInformationContent = styled(ContentMain)`
  h3 {
    margin-bottom: 32px;
  }
`;
